/*
 * @Autor: Baowang
 * @Date: 2023-07-03 17:39:29
 * @pageName: 配置域名文件
 * @LastEditTime: 2024-11-18 17:32:40
 */
export default {
	// HOST:"https://hgnl.yunqizhongguo.com/", // 公司
	HOST:"https://www.nalakzpark.com", // 客户
}